import { EventCoordinates } from "../components/events/event-creation/map-preview";

export const forwardGeocode = async (
  text: string,
): Promise<EventCoordinates | null> => {
  try {
    const res = await fetch(
      `https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(text)}&format=json&limit=1`,
      { headers: { "User-Agent": "YourAppName/1.0" } },
    );
    const json = await res.json();
    if (!json[0]) return null;
    return { lat: parseFloat(json[0].lat), lng: parseFloat(json[0].lon) };
  } catch {
    return null;
  }
};
